import { CMSImageProps } from "@jwm/types/CMSImageProps";
import { CMSColumnHorizontalAlign } from "@jwm/types/CMSRowProps";
import React from "react";

import { JWMLinkedImage, JWMNonLinkedImage } from "./Images";
import style from "./style.module.scss";

interface Props {
    imageLink: {
        url: string;
        url_prefix: string;
        external: boolean;
        title?: string;
        anchor_id?: string;
    };
    image: CMSImageProps;
    extension: string;
    placement?: string;
    sectionIndex?: number;
    horizontalAlignment?: CMSColumnHorizontalAlign;
}

export const JWMImage = (props: Props): JSX.Element => {
    const { image, extension = "jpg", imageLink, placement, sectionIndex = 0, horizontalAlignment = "Center" } = props;
    return (
        <div
            className={style.image}
            style={
                image?.fit?.toLowerCase() === "none" || horizontalAlignment !== "Center"
                    ? {
                          maxWidth: `${image?.image?.dimension?.width}px`,
                      }
                    : {}
            }
        >
            {imageLink.url !== "" ? (
                <JWMLinkedImage
                    extension={extension}
                    image={image}
                    imageLink={imageLink}
                    placement={placement}
                    loading={sectionIndex === 0 ? "eager" : "lazy"}
                />
            ) : (
                <JWMNonLinkedImage
                    extension={extension}
                    image={image}
                    loading={sectionIndex === 0 ? "eager" : "lazy"}
                />
            )}
        </div>
    );
};
export default JWMImage;
